import { forwardRef } from "react";
import { Link as RouterLink, type LinkProps } from "react-router-dom";
import { pagePath } from "../lib/routes";

// Normalize every site link at the shared boundary, including data-driven links.
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(function PageLink(
  { to, ...props },
  ref,
) {
  const destination = typeof to === "string"
    ? pagePath(to)
    : { ...to, pathname: to.pathname ? pagePath(to.pathname) : to.pathname };
  return <RouterLink {...props} to={destination} ref={ref} />;
});
